import React from "react";

export default function BsAt() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.659 10.915c0-4.45-3.374-7.548-8.223-7.548-5.025 0-8.47 3.477-8.47 8.553 0 5.24 3.353 8.562 8.644 8.562 1.293 0 2.533-.184 3.456-.502v-1.293c-.645.298-2.031.492-3.435.492-4.39 0-7.22-2.82-7.22-7.197 0-4.266 2.882-7.322 6.891-7.322 4.103 0 6.912 2.532 6.912 6.234 0 2.523-.83 4.154-2.124 4.154-.738 0-1.158-.42-1.158-1.14V7.89h-1.548v1.251h-.165c-.399-.892-1.321-1.446-2.4-1.446-2.1 0-3.567 1.743-3.567 4.235 0 2.605 1.436 4.359 3.569 4.359 1.2 0 2.122-.585 2.563-1.63h.165c.122 1.004 1.055 1.721 2.255 1.721 2.358 0 3.855-2.122 3.855-5.464v-.002ZM8.893 11.971c0-1.795.81-2.86 2.184-2.86 1.395 0 2.286 1.107 2.286 2.86 0 1.754-.901 2.871-2.307 2.871-1.342 0-2.163-1.087-2.163-2.87Z"
        fill="#currentColor"
      />
    </svg>
  );
}
